"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withdrawHelper = require("../../helpers/withdrawHelper");
var _sendReceiveComponent = require("../../propTypes/sendReceiveComponent");
var _SendReceiveHeaderComponent = _interopRequireDefault(require("./SendReceiveHeader/SendReceiveHeaderComponent"));
var _SendReceiveFormTabsComponent = _interopRequireDefault(require("./SendReceiveFormTabs/SendReceiveFormTabsComponent"));
var _SendFormContainer = _interopRequireDefault(require("./SendForm/SendFormContainer"));
var _ReceiveContainer = _interopRequireDefault(require("./Receive/ReceiveContainer"));
var _SendReceiveDetailsComponent = _interopRequireDefault(require("./SendReceiveDetails/SendReceiveDetailsComponent"));
var _SendReceiveConfirmModalComponent = _interopRequireDefault(require("./SendReceiveConfirmModal/SendReceiveConfirmModalComponent"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./SendReceiveSidePane.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var sendReceiveClasses = (0, _cssClassesHelper.getBEMClasses)('send-receive');
var SendReceiveSidePane = /*#__PURE__*/function (_React$Component) {
  function SendReceiveSidePane(props) {
    var _this;
    _classCallCheck(this, SendReceiveSidePane);
    _this = _callSuper(this, SendReceiveSidePane, [props]);
    _defineProperty(_this, "toggleUseExternalAddress", function () {
      _this.setState({
        useExternalAddress: !_this.state.useExternalAddress
      });
    });
    _defineProperty(_this, "onUpdate", function () {
      _this.getWithdrawFee();
      _this.setTotal();
    });
    _defineProperty(_this, "setTotal", function () {
      var position = _this.props.position;
      var _this$state = _this.state,
        Amount = _this$state.data.Amount,
        fee = _this$state.fee;
      var balance = (0, _withdrawHelper.getAvailableBalance)(position === null || position === void 0 ? void 0 : position.Amount, position === null || position === void 0 ? void 0 : position.Hold);
      var amount = parseFloat(Amount);
      var total = 0;
      if (amount) {
        total = (0, _withdrawHelper.getTotalRender)(balance, amount, fee);
      }
      _this.setState({
        total: total
      });
    });
    _defineProperty(_this, "getWithdrawFee", function () {
      var _this$props = _this.props,
        AccountProviderId = _this$props.AccountProviderId,
        ProductId = _this$props.product.ProductId,
        getWithdrawFee = _this$props.getWithdrawFee;
      var Amount = _this.state.data.Amount;
      if (!isNaN(Amount)) {
        getWithdrawFee(ProductId, Amount, AccountProviderId);
      }
    });
    _defineProperty(_this, "onDataUpdate", function (data) {
      var _this$state2 = _this.state,
        Amount = _this$state2.data.Amount,
        isSend = _this$state2.isSend;
      _this.setState({
        data: data
      }, function () {
        if (isSend && data.Amount !== Amount) {
          _this.onUpdate();
        }
      });
    });
    _defineProperty(_this, "openConfirmModal", function (data) {
      return _this.setState({
        openConfirmModal: true,
        data: data
      });
    });
    _defineProperty(_this, "closeConfirmModal", function () {
      return _this.setState({
        openConfirmModal: false
      });
    });
    _defineProperty(_this, "onTabChange", function () {
      _this.setState({
        isSend: !_this.state.isSend,
        data: {},
        useExternalAddress: true
      });
    });
    _defineProperty(_this, "submitData", function () {
      var _this$props2 = _this.props,
        receiveFunds = _this$props2.receiveFunds,
        sendFunds = _this$props2.sendFunds,
        sendToAddress = _this$props2.sendToAddress,
        ProductId = _this$props2.product.ProductId,
        template = _this$props2.template,
        TemplateType = _this$props2.template.TemplateType,
        selectedAccountId = _this$props2.selectedAccountId;
      var _this$state3 = _this.state,
        isSend = _this$state3.isSend,
        useExternalAddress = _this$state3.useExternalAddress,
        data = _this$state3.data,
        _this$state3$data = _this$state3.data,
        Notes = _this$state3$data.Notes,
        ReceiverUsername = _this$state3$data.ReceiverUsername,
        Amount = _this$state3$data.Amount;
      var payload = {
        Notes: Notes || '',
        ReceiverUsername: ReceiverUsername,
        Amount: Amount,
        ProductId: ProductId,
        selectedAccountId: selectedAccountId
      };
      var addressPayload = {
        ProductId: ProductId,
        Amount: Amount,
        TemplateType: TemplateType,
        TemplateForm: _objectSpread(_objectSpread({}, template), data)
      };
      if (isSend) {
        if (useExternalAddress) {
          sendToAddress(addressPayload);
        } else {
          sendFunds(payload);
        }
      } else {
        receiveFunds(payload);
      }
      _this.closeConfirmModal();
    });
    _this.state = {
      isSend: props.isSend,
      useExternalAddress: true,
      data: {},
      openConfirmModal: false,
      fee: null
    };
    return _this;
  }
  _inherits(SendReceiveSidePane, _React$Component);
  return _createClass(SendReceiveSidePane, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onSidePaneOpen({
        customClass: this.props.showDetails ? 'retail-sidepane-with-details' : 'retail-sidepane',
        hideHeader: true
      });
      if (JSON.stringify(this.props.position) !== '{}') {
        this.props.selectPositionAndSave(this.props.position.ProductId);
      }
      if (this.props.verificationLevelConfig.RequireWhitelistedAddress) {
        this.props.fetchAccountWithdrawInfos();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.fee !== this.state.fee) {
        this.setTotal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        product = _this$props3.product,
        position = _this$props3.position,
        fee = _this$props3.fee,
        showDetails = _this$props3.showDetails,
        allowTransfer = _this$props3.allowTransfer,
        hideFees = _this$props3.hideFees,
        TicketAmount = _this$props3.TicketAmount,
        verificationLevelConfig = _this$props3.verificationLevelConfig;
      var _this$state4 = this.state,
        isSend = _this$state4.isSend,
        useExternalAddress = _this$state4.useExternalAddress,
        data = _this$state4.data,
        openConfirmModal = _this$state4.openConfirmModal,
        total = _this$state4.total;
      var balance = (0, _withdrawHelper.getAvailableBalance)(position === null || position === void 0 ? void 0 : position.Amount, position === null || position === void 0 ? void 0 : position.Hold);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: sendReceiveClasses()
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: sendReceiveClasses('main')
      }, /*#__PURE__*/_react["default"].createElement(_SendReceiveHeaderComponent["default"], {
        product: product
      }), /*#__PURE__*/_react["default"].createElement("section", {
        className: sendReceiveClasses('main-form')
      }, /*#__PURE__*/_react["default"].createElement(_SendReceiveFormTabsComponent["default"], {
        isSend: isSend,
        toggleTab: this.onTabChange
      }), isSend ? /*#__PURE__*/_react["default"].createElement(_SendFormContainer["default"], {
        product: product,
        useExternalAddress: useExternalAddress,
        balance: balance,
        fee: fee,
        total: total,
        showDetails: showDetails,
        toggleUseExternalAddress: this.toggleUseExternalAddress,
        onChange: this.onDataUpdate,
        onSubmit: this.openConfirmModal,
        allowTransfer: allowTransfer,
        verificationLevelConfig: verificationLevelConfig
      }) : /*#__PURE__*/_react["default"].createElement(_ReceiveContainer["default"], {
        product: product,
        useExternalAddress: useExternalAddress,
        toggleUseExternalAddress: this.toggleUseExternalAddress,
        onChange: this.onDataUpdate,
        onSubmit: this.openConfirmModal,
        allowTransfer: allowTransfer
      }))), showDetails && /*#__PURE__*/_react["default"].createElement("section", {
        className: sendReceiveClasses('side')
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: sendReceiveClasses(isSend ? 'send-side-details' : 'side-details')
      }, /*#__PURE__*/_react["default"].createElement(_SendReceiveDetailsComponent["default"], {
        isSend: isSend,
        useExternalAddress: useExternalAddress,
        details: data,
        balance: balance,
        product: product,
        TicketAmount: TicketAmount,
        fee: fee
      }))), /*#__PURE__*/_react["default"].createElement(_SendReceiveConfirmModalComponent["default"], {
        isOpen: openConfirmModal,
        useExternalAddress: useExternalAddress,
        close: this.closeConfirmModal,
        product: product,
        isSend: isSend,
        values: data,
        fee: fee,
        onConfirm: this.submitData,
        hideFees: hideFees,
        TicketAmount: TicketAmount || data.Amount
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.fee !== prevState.fee) {
        return {
          fee: nextProps.fee
        };
      }
      return null;
    }
  }]);
}(_react["default"].Component);
SendReceiveSidePane.defaultProps = {
  showDetails: true,
  onSidePaneOpen: function onSidePaneOpen() {},
  isSend: true
};
SendReceiveSidePane.propTypes = {
  allowTransfer: _propTypes["default"].bool.isRequired,
  openRetailSendSidePane: _propTypes["default"].func,
  openRetailReceiveSidePane: _propTypes["default"].func,
  product: _sendReceiveComponent.product,
  position: _propTypes["default"].shape({
    AccountId: _propTypes["default"].number,
    Amount: _propTypes["default"].number,
    Hold: _propTypes["default"].number,
    OMSId: _propTypes["default"].number,
    PendingDeposits: _propTypes["default"].number,
    PendingWithdraws: _propTypes["default"].number,
    ProductId: _propTypes["default"].number,
    ProductSymbol: _propTypes["default"].string,
    TotalDayDeposits: _propTypes["default"].number,
    TotalDayWithdraws: _propTypes["default"].number,
    TotalMonthWithdraws: _propTypes["default"].number,
    TotalYearWithdraws: _propTypes["default"].number
  })
};
var _default = exports["default"] = SendReceiveSidePane;